var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBeamGraphic = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 300,
  height: 370,
  viewBox: "0 0 300 370",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "beam-graphic-a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "6.488%",
  stopColor: "#00FFFB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00FFF6"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "beam-graphic-c",
  cx: 89.749,
  cy: 96.858,
  rx: 2.087,
  ry: 2.152
}), /*#__PURE__*/React.createElement("filter", {
  id: "beam-graphic-b",
  width: "387.5%",
  height: "378.8%",
  x: "-143.7%",
  y: "-139.4%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "beam-graphic-e",
  cx: 14.61,
  cy: 55.963,
  rx: 2.087,
  ry: 2.152
}), /*#__PURE__*/React.createElement("filter", {
  id: "beam-graphic-d",
  width: "387.5%",
  height: "378.8%",
  x: "-143.7%",
  y: "-139.4%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "beam-graphic-g",
  cx: 85.575,
  cy: 23.676,
  rx: 2.087,
  ry: 2.152
}), /*#__PURE__*/React.createElement("filter", {
  id: "beam-graphic-f",
  width: "387.5%",
  height: "378.8%",
  x: "-143.7%",
  y: "-139.4%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "beam-graphic-i",
  cx: 68.877,
  cy: 40.896,
  rx: 4.174,
  ry: 4.305
}), /*#__PURE__*/React.createElement("filter", {
  id: "beam-graphic-h",
  width: "243.7%",
  height: "239.4%",
  x: "-71.9%",
  y: "-69.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "beam-graphic-k",
  cx: 4.174,
  cy: 90.401,
  rx: 4.174,
  ry: 4.305
}), /*#__PURE__*/React.createElement("filter", {
  id: "beam-graphic-j",
  width: "243.7%",
  height: "239.4%",
  x: "-71.9%",
  y: "-69.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "beam-graphic-m",
  cx: 76.182,
  cy: 63.496,
  rx: 1.044,
  ry: 1.076
}), /*#__PURE__*/React.createElement("filter", {
  id: "beam-graphic-l",
  width: "674.9%",
  height: "657.5%",
  x: "-287.5%",
  y: "-278.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "beam-graphic-o",
  cx: 34.439,
  cy: 1.076,
  rx: 1.044,
  ry: 1.076
}), /*#__PURE__*/React.createElement("filter", {
  id: "beam-graphic-n",
  width: "674.9%",
  height: "657.5%",
  x: "-287.5%",
  y: "-278.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "beam-graphic-q",
  cx: 17.741,
  cy: 35.515,
  rx: 1.044,
  ry: 1.076
}), /*#__PURE__*/React.createElement("filter", {
  id: "beam-graphic-p",
  width: "674.9%",
  height: "657.5%",
  x: "-287.5%",
  y: "-278.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  fill: "#E2E5E8",
  points: "150 17.675 0 148.001 0 289.09 99.031 370 201 370 300 289.392 300 149.392"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#4F5A65",
  points: "150 47.675 10 158.739 10 279.694 99.031 370 201 370 290 279.694 290 158.739"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(93)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 261)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#476687",
  d: "M16.2478575,18.1971956 C37.9116674,7.26760148 73.0883326,7.26760148 94.7521425,18.1971956 C116.415952,29.1264945 116.415952,46.8732103 94.7521425,57.8028044 C73.0883326,68.7323985 37.9116674,68.7323985 16.2478575,57.8028044 C-5.41595249,46.8732103 -5.41595249,29.1264945 16.2478575,18.1971956 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#90AECE",
  d: "M16.2478575,8.19722798 C37.9116674,-2.73240933 73.0883326,-2.73240933 94.7521425,8.19722798 C116.415952,19.1265701 116.415952,36.8733561 94.7521425,47.8029934 C73.0883326,58.7323355 37.9116674,58.7323355 16.2478575,47.8029934 C-5.41595249,36.8733561 -5.41595249,19.1265701 16.2478575,8.19722798 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M42.4217753,34.9834746 C41.4120998,34.4860751 41.4120998,33.6724083 42.4217753,33.1750088 L48.2959874,30.2811778 C49.3053729,29.7837783 50.9576219,29.7837783 51.9670074,30.2811778 C52.9766829,30.7785773 52.9766829,31.5925298 51.9670074,32.0899293 L46.0930854,34.9834746 C45.0834099,35.4808741 43.4314508,35.4808741 42.4217753,34.9834746 Z M76.5648715,38.4198453 L58.9425254,47.1013382 C56.5102572,48.2995539 52.5637656,48.2995539 50.1314974,47.1013382 L17.8242012,31.1854107 C15.3919329,29.987195 15.3919329,28.0430228 17.8242012,26.8448071 L35.4462573,18.1635999 C37.8785256,16.9653841 41.8253071,16.9653841 44.2572854,18.1635999 L45.7259834,18.8869862 L51.5999054,15.9931552 C59.7135556,11.9962458 72.9211086,12.000817 81.0162008,16.0157253 C89.1023039,20.0263482 88.9463,26.5328253 80.8326498,30.5300204 L75.0961735,33.3558554 L76.5648715,34.0792417 C78.9971398,35.2774574 78.9971398,37.2216296 76.5648715,38.4198453 Z M48.6630894,20.3340445 L72.1593575,31.9090827 L78.0332795,29.0152517 C84.5132389,25.8231525 84.5132389,20.6323128 78.0332795,17.4402136 C71.5536102,14.2478286 61.0169707,14.2478286 54.5370114,17.4402136 L48.6630894,20.3340445 Z M56.0057094,45.6542799 L73.6277655,36.9730726 C74.4356219,36.5750959 74.4356219,35.9239911 73.6277655,35.5263 L41.3204693,19.6103725 C40.5126129,19.2126815 39.1909297,19.2126815 38.3833633,19.6103725 L20.7610172,28.2918654 C19.9534508,28.6895565 19.9534508,29.3406613 20.7610172,29.7386381 L53.0686034,45.6542799 C53.8761698,46.0522566 55.197853,46.0522566 56.0057094,45.6542799 Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#beam-graphic-a)",
  fillOpacity: 0.2,
  d: "M2,289 C2,297.604378 14.2817828,317 55.7310813,317 C97.1803798,317 113,299 113,289 C113,282.333333 112.958792,186.016987 112.876377,0.0509608987 L0.632262266,0.0509608987 C1.54408742,186.947401 2,283.263748 2,289 Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "ring",
  stroke: "#07EEEB",
  strokeWidth: 2,
  d: "M18.830014,234.882411 C40.104403,223.733044 74.6461963,223.733044 95.9205853,234.882411 C117.194974,246.028768 117.194974,264.130307 95.9205853,275.276664 C74.6461963,286.42302 40.104403,286.42302 18.830014,275.276664 C-2.44150201,264.130307 -2.44150201,246.028768 18.830014,234.882411 Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "ring",
  stroke: "#07EEEB",
  d: "M18.305079,192.166674 C39.9281336,181.038761 75.0360317,181.038761 96.6590864,192.166674 C118.282141,203.291581 118.282141,221.358286 96.6590864,232.483194 C75.0360317,243.608101 39.9281336,243.608101 18.305079,232.483194 C-3.3150556,221.358286 -3.3150556,203.291581 18.305079,192.166674 Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "ring",
  stroke: "#07EEEB",
  d: "M18.305079,148.661991 C39.9281336,137.534079 75.0360317,137.534079 96.6590864,148.661991 C118.282141,159.786899 118.282141,177.853604 96.6590864,188.978512 C75.0360317,200.103419 39.9281336,200.103419 18.305079,188.978512 C-3.3150556,177.853604 -3.3150556,159.786899 18.305079,148.661991 Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.107 168.069)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#beam-graphic-b)",
  xlinkHref: "#beam-graphic-c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#00FFF6",
  xlinkHref: "#beam-graphic-c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#beam-graphic-d)",
  xlinkHref: "#beam-graphic-e"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF6AC",
  xlinkHref: "#beam-graphic-e"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#beam-graphic-f)",
  xlinkHref: "#beam-graphic-g"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#00FFF6",
  xlinkHref: "#beam-graphic-g"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#beam-graphic-h)",
  xlinkHref: "#beam-graphic-i"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF6AC",
  xlinkHref: "#beam-graphic-i"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#beam-graphic-j)",
  xlinkHref: "#beam-graphic-k"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#00FFF6",
  xlinkHref: "#beam-graphic-k"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#beam-graphic-l)",
  xlinkHref: "#beam-graphic-m"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#00FFF6",
  xlinkHref: "#beam-graphic-m"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#beam-graphic-n)",
  xlinkHref: "#beam-graphic-o"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF6AC",
  xlinkHref: "#beam-graphic-o"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#beam-graphic-p)",
  xlinkHref: "#beam-graphic-q"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#00FFF6",
  xlinkHref: "#beam-graphic-q"
})))))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBeamGraphic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/beam-graphic.3243442b.svg";
export { ForwardRef as ReactComponent };